import { render, staticRenderFns } from "./tipsView.vue?vue&type=template&id=6437ac2c&scoped=true"
import script from "./tipsView.vue?vue&type=script&lang=js"
export * from "./tipsView.vue?vue&type=script&lang=js"
import style0 from "./tipsView.vue?vue&type=style&index=0&id=6437ac2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437ac2c",
  null
  
)

export default component.exports